import { render, staticRenderFns } from "./LogItem.vue?vue&type=template&id=d2b62df4&scoped=true"
import script from "./LogItem.vue?vue&type=script&lang=js"
export * from "./LogItem.vue?vue&type=script&lang=js"
import style0 from "./LogItem.vue?vue&type=style&index=0&id=d2b62df4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b62df4",
  null
  
)

export default component.exports